import {
  init,
  browserTracingIntegration,
  replayIntegration,
} from "@sentry/vue";
import router from "@/router";
import { isWeb } from "./capacitor";

import { initSentry as nativeInitSentry } from "./capacitor/sentryPlugin";

const DSN =
  "https://7e1475367f64e3212c4a2c6b33ef3430@o4508520892268544.ingest.us.sentry.io/4508974447067136";

export const initSentry = async (app: any) => {
  if (import.meta.env.VITE_NODE_ENV === "development") return; // dev mode return
  if (isWeb) {
    init({
      app,
      dsn: DSN,
      integrations: [
        browserTracingIntegration({ router }),
        replayIntegration(),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      // Session Replay
      tracePropagationTargets: [
        "localhost",
        "192.168.13.226",
        /^https:\/\/yourserver\.io\/api/,
      ],
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  } else {
    nativeInitSentry(app);
  }
};
